"use client";

import { useState } from "react";

export default function ContentEnrichmentTool() {
  const [contentType, setContentType] = useState("Text");
  const [geography, setGeography] = useState("Geography");
  const [generation, setGeneration] = useState("Generation");
  const [outputLanguage, setOutputLanguage] = useState("English");
  const [countries, setCountries] = useState("Brazil");
  const [socialMedia, setSocialMedia] = useState("Instagram");

  // Adjust options based on selected geography type
  const geographyOptions: Record<string, { value: string; label: string }[]> = {
    Geography: [
      { value: "World", label: "World" },
    ],
    Region: [
      { value: "NA", label: "North America" },
      { value: "EU", label: "Europe" },
      { value: "AS", label: "Asia" },
      { value: "AF", label: "Africa" },
      { value: "SA", label: "South America" },
      { value: "OC", label: "Oceania" },
    ],
    Country: [
      { value: "BR", label: "Brazil" },
      { value: "US", label: "United States" },
      { value: "FR", label: "France" },
      { value: "DE", label: "Germany" },
      // ... other countries
    ],
  };

  // Use the selected geography type to determine the options
  const currentOptions = geographyOptions[geography] || [];

  return (
    <div className="container is-flex is-justify-content-center" style={{ width: '100%' }}>
      <div className="box m-5">
        <div className="columns is-multiline is-vcentered">
          <div className="column is-narrow">
            <div className="icon is-medium">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/public-contents.appspot.com/o/Quen%2FQuennar.png?alt=media&token=009f9f91-b530-4f85-b004-f1dc77d26851"
                alt="Logo"
                className="image"
              />
            </div>
          </div>
          <span className="has-text-weight-medium ml-2">
            Enrich the following
          </span>

          <div className="column is-narrow">
            <div className="select">
              <select
                value={contentType}
                onChange={(e) => setContentType(e.target.value)}
              >
                <option value="Text">Text</option>
                <option value="Image">Image</option>
                <option value="Video">Video</option>
              </select>
            </div>
          </div>

          <div className="column is-narrow">
            <span className="has-text-weight-medium">
              for a culture target by
            </span>
          </div>

          <div className="column is-narrow">
            <div className="select">
              <select
                value={geography}
                onChange={(e) => setGeography(e.target.value)}
              >
                <option value="Geography">Geography</option>
                <option value="Region">Region</option>
                <option value="Country">Country</option>
              </select>
            </div>
          </div>

          <div className="column is-narrow">
            <span className="has-text-weight-medium">as</span>
          </div>

          <div className="column is-narrow">
            <div className="select">
              <select
                value={countries}
                onChange={(e) => setCountries(e.target.value)}
              >
                {currentOptions.map((option: { value: string; label: string }) => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className="columns is-multiline is-vcentered mt-4">
          <div className="column is-narrow">
            <span className="has-text-weight-medium">within</span>
          </div>

          <div className="column is-narrow">
            <div className="select">
              <select
                value={generation}
                onChange={(e) => setGeneration(e.target.value)}
              >
                <option value="Generation">Generation</option>
                <option value="Gen Z">Gen Z</option>
                <option value="Millennials">Millennials</option>
                <option value="Gen X">Gen X</option>
                <option value="Boomers">Boomers</option>
              </select>
            </div>
          </div>

          <div className="column is-narrow">
            <span className="has-text-weight-medium">Who uses</span>
          </div>

          <div className="column is-narrow">
            <div className="select">
              <select
                value={socialMedia}
                onChange={(e) => setSocialMedia(e.target.value)}
              >
                <option value="Instagram">Instagram</option>
                <option value="Facebook"> Facebook</option>
                <option value="Twitter"> Twitter</option>
                <option value="LinkedIn"> LinkedIn</option>
              </select>
            </div>
          </div>

          <div className="column is-narrow">
            <span className="has-text-weight-medium">
              present the output in
            </span>
          </div>

          <div className="column is-narrow">
            <div className="select">
              <select
                value={outputLanguage}
                onChange={(e) => setOutputLanguage(e.target.value)}
              >
                <option value="English">English</option>
                <option value="Portuguese">Portuguese</option>
                <option value="Spanish">Spanish</option>
                <option value="Chinese">Chinese</option>
                <option value="Hindi">Hindi</option>
                <option value="Japanese">Japanese</option>
                <option value="Korean">Korean</option>
                <option value="Russian">Russian</option>
                <option value="French">French</option>
                <option value="German">German</option>
                <option value="Italian">Italian</option>
                <option value="Dutch">Dutch</option>
                <option value="Swedish">Swedish</option>
                <option value="Turkish">Turkish</option>
                <option value="Arabic">Arabic</option>
                <option value="Thai">Thai</option>
                <option value="Indonesian">Indonesian</option>
                <option value="Polish">Polish</option>
                <option value="Filipino">Filipino</option>
                <option value="Malay">Malay</option>
                <option value="Hebrew">Hebrew</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
